import { ApiGenericResponse } from "../../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

const ENDPOINT = "/dashboard/widget";

export class DeleteDashboardWidgetCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";

    params: DeleteWidgetReqData = null;

    constructor(widgetId: number) {
        super();
        this.params = new DeleteWidgetReqData(widgetId);
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class DeleteWidgetReqData {
    id: number;
    constructor(widgetId: number) {
        this.id = widgetId;
    }
}
